import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  CREDITORS_SEARCH_REQUEST,
  CREDITORS_SEARCH_SUCCESS,
  CREDITORS_SEARCH_ERROR,
  CREDITOR_DATA_REQUEST,
  CREDITOR_DATA_SUCCESS,
  CREDITOR_DATA_ERROR,
} from '../actions';

const initialState = {
  data: [],
  datasets: [],
  meta: {},
  lastUpdated: '',
  error: '',
  current: {
    status: STATUS_NOT_REQUESTED,
    creditor: '',
    data: [],
    error: '',
  },
};

export const creditors = (state = initialState, action) => {
  switch (action.type) {
    case CREDITORS_SEARCH_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
        storedPayload: initialState.storedPayload,
      };

    case CREDITORS_SEARCH_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        datasets: action.payload.datasets,
        meta: action.payload.meta,
        lastUpdated: action.payload.lastUpdated,
        storedPayload: action.payload.payload,
        status: STATUS_SUCCESS,
      };

    case CREDITORS_SEARCH_ERROR:
      return {
        ...state,
        error: action.payload.error?.message || 'error',
        status: STATUS_ERROR,
        datasets: [],
        data: [],
      };

    case CREDITOR_DATA_REQUEST:
      return {
        ...state,
        current: {
          ...state.current,
          status: STATUS_LOADING,
          data: initialState.current.data,
        },
      };

    case CREDITOR_DATA_SUCCESS:
      return {
        ...state,
        current: {
          status: STATUS_SUCCESS,
          data: action.payload.data,
          creditor: action.payload.accountName,
        },
      };

    case CREDITOR_DATA_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          status: STATUS_ERROR,
          error: action.payload.error?.message || 'error',
        },
      };

    default:
      return state;
  }
};
